import * as React from 'react';
import omit from 'rc-util/lib/omit';
import classNames from 'classnames';
import Element from './Element';
import { ConfigConsumer } from '../config-provider';
const SkeletonInput = (props) => {
    const renderSkeletonInput = ({ getPrefixCls }) => {
        const { prefixCls: customizePrefixCls, className, active } = props;
        const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
        const otherProps = omit(props, ['prefixCls']);
        const cls = classNames(prefixCls, `${prefixCls}-element`, {
            [`${prefixCls}-active`]: active,
        }, className);
        return (<div className={cls}>
        <Element prefixCls={`${prefixCls}-input`} {...otherProps}/>
      </div>);
    };
    return <ConfigConsumer>{renderSkeletonInput}</ConfigConsumer>;
};
SkeletonInput.defaultProps = {
    size: 'default',
};
export default SkeletonInput;
